import styled from 'styled-components';

export const StyledManualEntry = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props): string => props.theme.kcc.spacing.LG};
  flex: 1;
  max-width: 755px;

  .manual-entry__or {
    text-align: center;
    color: ${(props): string => props.theme.kcc.colors.GRAY_600};
    display: block;
  }

  .manual-entry__scan-btn {
    width: 100%;
    max-width: 755px;
  }
`;
